import { PUBLIC_PATHS } from '@app/hooks/useSubdomain'

export function checkIsPublicRoute(pathname: string): boolean {
  return PUBLIC_PATHS.some((pattern) => pattern.test(pathname))
}
